<script>
  import { onMount,onDestroy, tick } from 'svelte';
  let adData = null;
  let adPullUrl = "https://api-test.zzspider.com/xl-api/1.0/advertising/advertising/pull";
  let adReportUrl = "https://api-test.zzspider.com/xl-api/1.0/advertising/advertising/ack";
  export let appid;
  export let user_id;
  export let provider;
  export let provider_name = undefined;
  export let space_code;
  export let development = false;
  export let onSuccess; // 广告拉取成功事件回调
  export let onFail; // 广告拉取失败事件回调
  export let onLoad; // 广告渲染成功事件回调
  export let onClick; // 广告点击事件回调
  export let customPopup = false;
  export let popupCloseStyle = "default"; // 支持default large


  let popupShow = true;
  let rafId;
  let container;
  let textElement;
  let position = 0;
  let shouldScroll = false;
  let interval = null;
  let countDown = 7;
  let mark = true;

  function closePopup() {
    popupShow = false;
  }

  let modalType = "bottom";

  let styles = {
    position: "relative",
    width: '100%',
    height: '100%',
  }

  let popupStyles = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.6)",
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
    "z-index": 1000,
  }

  let popupContentStyles = {
    padding: "20px",
    "border-radius": "8px",
    width: "60%",
    "max-width": "400px",
    position: "relative",
  }

  let closeButtonStyles = {
    position: "absolute",
    right: "15px",
    top: "-40px",
    width: "40px",
    height: "40px",
    background: "none",
    "text-align": "center",
    "border-radius": '50%',
    "background-color": "rgba(0,0,0,0.2)", /* 主要的按钮颜色 */
    color: "#fff",/* 如果按钮内有文字或图标的颜色 */
    border: "1px solid rgba(255,255,255,0.2)", /* 边框颜色，确保与背景形成对比 */
    "box-shadow": "2px 2px 4px rgba(0,0,0,0.2)", /* 轻微的阴影，增加深度感 */
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
  }



  let closeButtonBottomStyles = {
      position: "relative",
      top: "20px",
      left: "50%",
      transform: "translateX(-50%)",
      width: "30px",
      height: "30px",
      background: "none",
      "text-align": "center",
      "border-radius": '50%',
      "background-color": "rgba(0,0,0,0.2)", /* 主要的按钮颜色 */
      color: "#fff",/* 如果按钮内有文字或图标的颜色 */
      border: "1px solid rgba(255,255,255,0.2)", /* 边框颜色，确保与背景形成对比 */
      "box-shadow": "2px 2px 4px rgba(0,0,0,0.2)", /* 轻微的阴影，增加深度感 */
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
  }

  let largeCloseButtonBottomStyles = {
    position: "relative",
    top: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    width: "40px",
    height: "40px",
    background: "none",
    "text-align": "center",
    "border-radius": '50%',
    "background-color": "rgba(0,0,0,0.2)", /* 主要的按钮颜色 */
    color: "#fff",/* 如果按钮内有文字或图标的颜色 */
    border: "2px solid rgba(255,255,255,0.8)", /* 边框颜色，确保与背景形成对比 */
    "box-shadow": "2px 2px 4px rgba(0,0,0,0.8)", /* 轻微的阴影，增加深度感 */
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
  }

  // 广告标识样式
  let adMarkstyles = {
    position: "absolute",
    left: '2px',
    top: '2px',
    width: '40px',
    height: '20px',
    "text-align": "center",
    color: '#fff',
    "background-color": "rgba(0,0,0,0.2)",
    "font-size": "12px",
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
  }

  let adPopupMarkstyles = {
    position: "absolute",
    right: '2px',
    top: '2px',
    width: '26px',
    height: '26px',
    "border-radius": "50%",
    "text-align": "center",
    color: '#fff',
    "background-color": "rgba(0,0,0,0.2)",
    "font-size": "12px",
    display: "flex",
    "align-items": "center",
    "justify-content": "center",
  }

  let scrollContainerStyles = {
    position: "relative",
    overflow: "hidden",
  }

  let scrollTextStyles = {
    "white-space": "nowrap",
    "will-change": "transform",
    transform: "translateX(0)",
    display: "inline-block"
  }
  
  /**
   * 验证参数合法性
   */
  function validateParameters(parameters) {
    const {appid, space_code, provider, user_id}  = parameters;
    if (!appid) {
      throw new Error("参数`appid`未设置");
    }
    if (!space_code) {
      throw new Error("参数`space_code`未设置");
    }
    // if (!provider) {
    //   throw new Error("参数`provider`未设置");
    // }
    // if (!user_id) {
    //   throw new Error("参数`user_id`未设置");
    // }
  }

  function confirmConfig(parameters) {
    const {appid, space_code, provider, user_id}  = parameters;
    if (appid === 'sp0yre7bi4ewgw1899' || appid === "sp04fqvk211o5xgrb4") {
      countDown = 5
    }
  }

  // 拉取广告
  function fetchAdPull(parameters) {
    return fetch(adPullUrl, {
      method: "POST",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(parameters)
    }).then(response => response.json())
  }
  

  // 广告事件上报 可以忽略上报之后的判断逻辑
  function reportAdEvent(adId, eventType) {
    let reportParameters = {
      id: adId,
      status: eventType,
    }
    // 由于跨域问题，暂不可用navigator.sendBeacon
    // if (navigator.sendBeacon) {
    //   const blob = new Blob([JSON.stringify(reportParameters)],{type : 'application/json'});
    //   navigator.sendBeacon(adReportUrl, blob);
    // } else {
    //   fetch(adReportUrl, {
    //     method: "POST",
    //     headers: {"Content-Type": "application/json"},
    //     body: JSON.stringify(reportParameters)
    //   })
    // }
    return fetch(adReportUrl, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(reportParameters)
      })
  }

  // 广告点击事件
  function handleClick(adId) {
    // 点击回调
    if (onClick && typeof onClick === 'function') {
      onClick(adData);
    }
    // 上报成功后进行调整
    reportAdEvent(adId, 2).then((res) => {
      location.href = adData.link;
    });
  }

  // 广告图片加载完毕
  function handleLoad(adId) {
    if (onLoad && typeof onLoad == 'function') {
      onLoad(adData);
    }
    reportAdEvent(adId, 1);
  }

  // 广告拉取成功
  function handleSuccess() {
    if (onSuccess && typeof onSuccess === "function") {
      onSuccess(adData);
    }
  }

  // 广告失败
  function handleFail(error) {
    console.error({
        error: error,
        props: {
          space_code:space_code,
          appid: appid,
          provider: provider,
          provider_name: provider_name,
          user_id: user_id,
        },
        adData: adData,
      })
    if (onFail && typeof onFail === 'function') {
      onFail({
        error: error,
        props: {
          space_code:space_code,
          appid: appid,
          provider: provider,
          provider_name: provider_name,
          user_id: user_id,
        },
        adData: adData,
      })
    }
  }

  // dom加载完毕
  onMount(() => {
    if (development) {
      adPullUrl = "https://api-test.zzspider.com/xl-api/1.0/advertising/advertising/pull";
      adReportUrl = "https://api-test.zzspider.com/xl-api/1.0/advertising/advertising/ack";
    } else {
      adPullUrl = "https://api.zzspider.com/xl-api/1.0/advertising/advertising/pull";
      adReportUrl = "https://api.zzspider.com/xl-api/1.0/advertising/advertising/ack";
    }
    try {
      validateParameters({appid,space_code,provider,user_id});
      confirmConfig({appid});
      fetchAdPull({appid,space_code,provider,user_id, provider_name}).then((res) => {
        if (res && res.code === 1) {
          adData = res.data;
          handleSuccess();
            // 确保此代码在数据更新和DOM渲染之后执行
          tick().then(() => {
            if (adData.template === "text") {
              handleLoad(adData.id);
              shouldScroll = textElement.offsetWidth > container.offsetWidth;
              if (shouldScroll) {
                requestScroll();
              }
            }
          });
          if (adData.template === "article") {
            location.href = adData.link;
          }
          if (adData.template === 'popup') {
            interval = setInterval(() => {
              countDown -= 1;
              if (countDown <=0) {
                popupShow = false;
                clearInterval(interval);
                interval = null;
              }
            }, 1000)
          }
        } else {
          throw new Error(res && res.message? res.message: '');
        }
      }).catch((error) => {
        handleFail(error);
      })
    } catch(error) {
      handleFail(error);
    }
  })

  function requestScroll() {
    rafId = requestAnimationFrame(scrollText);
  }

  function scrollText() {
    position -= 1; // 调整滚动速度
    if (-position > textElement.offsetWidth) {
      position = container.offsetWidth;
    }
    textElement.style.transform = `translateX(${position}px)`;
    requestScroll();
  }

  function stylesToString(styleObj) {
    return Object.entries(styleObj).map(([key,value]) => `${key}: ${value}`).join("; ")
  }


  onDestroy(() => {
    cancelAnimationFrame(rafId);
    clearInterval(interval);
    interval = null;
  })


</script>


<div>
  {#if adData}
    <div class="zz-component" >
      <!-- banner图片 -->
    {#if adData&&adData.template === "banner" || adData && adData.template === 'popup' && customPopup}
        <div class="zz-component-banner" style={stylesToString(styles)}>
          <a class="zz-link" href="javascript:void(0)" on:click={handleClick(adData.id)}>
            {#if adData.image}
              <img style="width: 100%;" src={adData.image} on:load={handleLoad(adData.id)} alt="">
            {/if}
          </a>
        </div>
      {/if}
      <!-- 弹窗 -->
      {#if adData&&adData.template === "popup" && popupShow}
        <div class="zz-component-popup">
          <div class="zz-popup-overlay" style={stylesToString(popupStyles)}>
            <div class="zz-popup-over" style={stylesToString(popupContentStyles)}>
              <div class="zz-popup-content" style="position: relative">
                <a class="zz-link" href="javascript:void(0)" on:click={handleClick(adData.id)}>
                  {#if adData.image}
                  <img style="width: 100%;" src={adData.image} on:load={handleLoad(adData.id)} alt="">
                  {#if mark}
                    <div class="zz-mark" style={stylesToString(adPopupMarkstyles)}>
                      {countDown + "s"}
                    </div>
                  {/if}           
                {/if}
                </a>
                {#if modalType === 'bottom'}
                  {#if popupCloseStyle === "large"}
                    <div class="zz-close-btn zz-close-btn-large" on:click={closePopup} style={stylesToString(largeCloseButtonBottomStyles)}>
                      <div class="zz-x-button"></div>
                    </div>
                  {/if}
                  {#if popupCloseStyle === "default"}
                    <div class="zz-close-btn" on:click={closePopup} style={stylesToString(closeButtonBottomStyles)}>
                      <div class="zz-x-button"></div>
                    </div>
                  {/if}
                {/if}
              </div>
              {#if modalType === 'right'}
              <div class="zz-close-btn" on:click={closePopup} style={stylesToString(closeButtonStyles)}>
                <div class="zz-x-button"></div>
              </div>
              {/if}
              </div>
          </div>
        </div>
      {/if}
      <!-- 文字链 -->
      {#if adData&&adData.template === "text"}
        <div class="zz-component-text">
          <a class="zz-link" href="javascript:void(0)" on:click={handleClick(adData.id)}>
            <div bind:this={container} class="zz-text-scroll" style={stylesToString(scrollContainerStyles)}>
              <div class="zz-text-content" bind:this={textElement} style={stylesToString(scrollTextStyles)}>{adData.text}</div>
            </div>
          </a>
        </div>
      {/if}
    </div>
  {/if}
</div>

<style>
  .zz-link {
    display: block;
    text-decoration: none;
  }
  .zz-x-button {
    position: relative;
    width: 12px;
    height: 12px;
    background: none;
    border: none;
    cursor: pointer;
    top: 6px;
  }
  .zz-close-btn-large .zz-x-button {
    width: 24px;
    height: 24px;
    top: 12px;
  }

  .zz-x-button::before,
  .zz-x-button::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: #fff;
  }

  .zz-close-btn-large .zz-x-button::before {
    height: 2px;
  }
  .zz-close-btn-large .zz-x-button::after {
    height: 2px;
  }

  .zz-x-button::before {
    transform: rotate(45deg);
  }

  .zz-x-button::after {
    transform: rotate(-45deg);
  }
  .zz-text-scroll {
    background: #3f85ed;
    width: 100%;
    height: 20px;
    line-height: 20px;
  }
  .zz-text-content {
    color: #ffffff;
    font-size: 14px;
  }
</style>